import React from "react";
import styled from "styled-components";
import { IconButton } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ShareIcon from "@material-ui/icons/Share";
import CopyIcon from "@material-ui/icons/FileCopy";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import Item from "../../inspect/components/tracker/item";
import { DarkTooltip } from "../../inspect/components/tooltip";
import Icon from "@material-ui/core/Icon";

const CustomRow = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  display: flex;
  gap: 10px;
  width: 100%;
  max-width: 1440px;
  margin-bottom: 10px;
  h4 {
    font-size: 1.125rem;
  }
  > div {
    padding: 10px 16px;
  }
  > div:nth-child(1) {
    flex-basis: 350px;
  }
  > div:nth-child(2) {
    flex: 2;
  }
`;

const Macros = styled.div`
  display: flex;
  span {
    color: #697f97;
    font-size: 0.9rem;
    font-weight: bold;
    padding: 0 10px 0 0;
  }
`;

const Notes = styled.div`
  p {
    display: flex;
    align-items: flex-start;
    font-size: 0.9rem;
    max-width: 600px;
  }

  span {
    font-size: 1rem;
    margin: 1px 6px;
    color: #070c29;
  }
`;

export const MealListItem = ({ meal, edit, copy, share, remove }) => {
  const wrapTooltip = (children) => {
    return (
      <DarkTooltip title={renderFoods(meal.foods)} delay={100}>
        <>{children}</>
      </DarkTooltip>
    );
  };

  const renderFoods = (foods) => {
    let foodString = "";
    if (foods) {
      foods.forEach((item) => {
        foodString += `${item.name}, `;
      });

      foodString = foodString.slice(0, -2);
    }
    return foodString;
  };

  const renderMacros = (foods) => {
    let protein = 0;
    let carbs = 0;
    let fat = 0;
    let calories = 0;
    let fiber = 0;

    foods.forEach((entry) => {
      const item = new Item(entry);
      if (item.itemType === "recipe") {
        protein += item.getRecipeProtein();
        carbs += item.getRecipeCarbs();
        fat += item.getRecipeFat();
        fiber += item.getRecipeFiber();
      } else {
        protein += item.getProtein();
        carbs += item.getCarbs();
        fat += item.getFat();
        fiber += item.getFiber();
      }
    });

    calories = ((4 * (carbs + protein)) + (9 * fat)).toFixed(0);
    protein = protein.toFixed(1);
    carbs = carbs.toFixed(1);
    fat = fat.toFixed(1);
    fiber = fiber.toFixed(1);

    return (
      <Macros>
        {meal.foods.length >= 1 ? (
          <>
            <span>{protein} P</span>
            <span>{carbs} C</span>
            <span>{fat} F</span>
            <span>{calories} Cal</span>
            <span>{fiber} Fiber</span>
          </>
        ) : (
          <span>No foods have been added</span>
        )}
      </Macros>
    );
  };

  return (
    <CustomRow>
      <div>
        <h4 style={{ display: "flex", alignItems: "center" }}>
          {meal.name}
          {meal.foods.length > 1 &&
            wrapTooltip(
              <Icon
                style={{ display: "flex", marginLeft: "6px", color: "#070c29" }}
              >
                search
              </Icon>
            )}
        </h4>
        {renderMacros(meal.foods)}
      </div>
      {meal.notes && (
        <Notes>
          <p>
            <Icon>description</Icon>
            {meal.notes}
          </p>
        </Notes>
      )}
      {edit && share && remove && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <IconButton
            color="inherit"
            onClick={() => edit(meal.id)}
            title="Edit"
          >
            <EditIcon />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={() => copy(meal.id)}
            title="Copy"
          >
            <CopyIcon />
          </IconButton>
          <IconButton
            color="inherit"
            onClick={() => share(meal.id)}
            title="Share"
          >
            <ShareIcon />
          </IconButton>
          <IconButton
            color="secondary"
            onClick={() => remove(meal)}
            title="Delete"
          >
            <DeleteIcon />
          </IconButton>
        </div>
      )}
    </CustomRow>
  );
};
